import { render } from "./SortTableBasicDataCellComponent.vue?vue&type=template&id=1d0eabee&scoped=true"
import script from "./SortTableBasicDataCellComponent.vue?vue&type=script&lang=js"
export * from "./SortTableBasicDataCellComponent.vue?vue&type=script&lang=js"

import "./SortTableBasicDataCellComponent.vue?vue&type=style&index=0&id=1d0eabee&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d0eabee"]])

export default __exports__